import { Button, ButtonTheme } from "@redotech/redo-web/button";
import { Flex } from "@redotech/redo-web/flex";
import { Modal } from "@redotech/redo-web/modal";
import { memo } from "react";

export const ContactRedoModal = memo(function ContactRedoModal({
  errorMessageHref,
  errorMessage,
  title,
}: {
  errorMessageHref: string;
  errorMessage?: string;
  title: string;
}) {
  return (
    <Modal hideCloseButton open title={title}>
      <Flex align="center" dir="column">
        {errorMessage && <span>{errorMessage}</span>}
        <span>Please reach out to support@getredo.com for assistance</span>
        <a href={errorMessageHref} rel="noreferrer" target="_blank">
          <Button theme={ButtonTheme.PRIMARY}>Email us</Button>
        </a>
      </Flex>
    </Modal>
  );
});
